module.exports = __webpack_public_path__ + "img/Porto Apartment - 32 of 85.d08263fa.jpeg";